import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import qs from 'query-string'
import ReactHtmlParser from 'react-html-parser'
import { BrowserView, MobileView, isMobile } from 'react-device-detect'

import Loader from '../Loader/Loader'

// import Variant from '../Variant/Variant'
import ProductTile from '../ProductTile/ProductTile'
import useStateCallback from '../../hooks/useStateCallback'

import './CollectionPlaceholder'

import './Collections.scss'

import {
    getShuffledArray,
    getUniqueListBy,
    dynamicSort,
    sortByKey,
    groupBy,
    slugify,
    insertParam,
    insertUrlParam,
    removeParam,
    formatQueryStringValues,
    removeQueryString,
    getProducts,
    getFirstProducts,
    getNextProducts,
} from '../../helpers/helpers'
import CollectionPlaceholder from './CollectionPlaceholder'

const boostLiveUrl =
    'https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&product_available=true&variant_available=true&limit=70&collection_scope='

const queryString = window.location.search
const parsed = qs.parse(queryString)

let slug = window.location.href.split('/').pop()

const Collection = React.memo(
    ({
        collectionData,
        collectionHandle,
        cid,
        collectionId,
        collectionPage,
        collectionTitle,
    }) => {
        // console.log('collectionId in Collection.js', collectionId)
        const [data, setData] = useStateCallback()
        const [numProducts, setNumProducts] = useStateCallback(0)
        const [numProductsRemaining, setNumProductsRemaining] =
            useStateCallback(0)
        const [pages, setPages] = useStateCallback(0)
        const [currentPage, setCurrentPage] = useStateCallback(1)
        const [initialData, setInitialData] = useStateCallback()
        const [variants, setVariants] = useStateCallback()
        const [productTiles, setProductTiles] = useStateCallback()

        const variantsWithInventoryRef = useRef()
        const [isLoading, setIsLoading] = useState(false)
        const [hasProducts, setHasProducts] = useState(true)

        const boostQueryUrl = useRef()

        let collectionDesc
        let uniqueVariants
        let products
        let allVariants
        let hiddenProduct

        if (
            !collectionId ||
            collectionId === 'undefined' ||
            collectionId === ''
        ) {
            // find the collection by handle/slug
            if (cid && cid.length) {
                collectionId = cid
            } else if (collectionData && collectionData.length) {
                collectionData.map((c) => {
                    // eslint-disable-next-line
                    if (c.handle == collectionHandle) {
                        // console.log('c', c)
                        collectionId = c.id
                        collectionTitle = c.title
                        collectionDesc = c['body-html']
                    }
                    return null
                })
            }


        }

        let boostUrl = `https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&page=1&collection_scope=${collectionId}&product_available=true&variant_available=true`

        useEffect(() => {
            // we don't have any filters (but could have utm params)

            fetch(boostUrl).then((res) =>
                res.json().then((productData) => {
                    console.log('productData in getNumProducts', productData)

                    // write backup date to file on server every Saturday at 2am
                    let run = false
                    const now = new Date()
                    const isoDate = new Date().toISOString().substring(0, 10)
                    if (
                        now.getDay() === 6 &&
                        now.getHours() === 2 &&
                        now.getMinutes() === 0 &&
                        !run
                    ) {
                        fetch(
                            'https://data.monicaandandy.com/plp/data/input.php',
                            {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    data: productData,
                                    collectionTitle: `${collectionHandle}`,
                                }),
                            }
                        )
                            .then((res) => res.json())
                            .then((data) => {
                                if (data.status == 200) {
                                    //when data is returned from backend
                                    const response = data.response
                                    console.log(response) //should print dataReceived
                                }
                            })
                        run = true
                    }

                    let numberOfProducts = productData.total_product
                    setNumProducts(numberOfProducts)

                    const products = productData.products

                    let productsNewTitle = products.map((p) => {
                        return {
                            ...p,
                            title: p.title.split('_')[0],
                        }
                    })

                    console.log('productsNewTitle', productsNewTitle)

                    let productsGrouped

                    if (productsNewTitle && productsNewTitle.length) {
                        productsGrouped = groupBy(productsNewTitle, 'title')
                    }

                    console.log('productsGrouped', productsGrouped)

                    let productsGroupedArray = []

                    for (const [key, value] of Object.entries(
                        productsGrouped
                    )) {
                        console.log('PG kv', key, value)
                        productsGroupedArray.push({
                            title: key,
                            products: value,
                        })
                    }

                    console.log('productsGroupedArray', productsGroupedArray)

                    setProductTiles(productsGroupedArray)

                    setData(productData.products.flat(1))
                    if (!initialData) {
                        setInitialData(productData.products.flat(1))
                    }
                })
            )

            // eslint-disable-next-line
        }, [])

        // set our variants
        // useEffect(() => {
        //     if (uniqueVariants && uniqueVariants.length) {
        //         if (
        //             collectionPage &&
        //             collectionPage === 'giveaway' &&
        //             (collectionId === 266036805694 ||
        //                 collectionId === '266036805694')
        //         ) {
        //             // console.log('babylist collection', collectionId)
        //             const uniqueVariants1 = uniqueVariants.slice(0, 16)
        //             // console.log('uniqueVariants1', uniqueVariants1)
        //             setVariants(uniqueVariants1)
        //         } else if (numProducts <= 70) {
        //             console.log('uniqueVariants', uniqueVariants)
        //             setVariants(uniqueVariants)
        //             setNumProductsRemaining(0)
        //             console.log('if = here')
        //         } else {
        //             setVariants(uniqueVariants)
        //             console.log('else = here')
        //         }
        //     } else {
        //         setHasProducts(uniqueVariants !== null)
        //         console.log('else else = here')
        //     }
        //     // eslint-disable-next-line
        // }, [data, uniqueVariants])

        // if (data && data) {
        //     console.log('data after query', data)
        //     products = [...data]

        //     let variants = products.map((p) => {
        //         return p.variants
        //     })

        //     variants = variants.flat(2)

        //     // console.log('variants', variants)

        //     let productTimes = products.map((p) => {
        //         // console.log('p, p.title', p, p.title)
        //         return {
        //             product_id: p.id,
        //             created_at: p.created_at,
        //             product_title: p.title,
        //         }
        //     })

        //     // we don't have a 'gender' property by default; add it for filtering
        //     let variantsWithGender = variants.map((v) => {
        //         let gender
        //         const options = v.merged_options
        //         const genderOption = options.find((o) => o.includes('gender:'))
        //         if (genderOption) {
        //             gender = genderOption.split(':')[1]
        //         }
        //         return { ...v, gender: gender ? gender : 'Unisex' }
        //     })

        //     let variantsWithTime = []
        //     variantsWithGender.map((v) => {
        //         productTimes.map((t) => {
        //             if (t.product_id.toString() === v.product_id.toString()) {
        //                 variantsWithTime.push({
        //                     ...v,
        //                     product_title: t.product_title,
        //                     created_at: t.created_at,
        //                     id_pattern:
        //                         v.initial_color && v.initial_color.length
        //                             ? t.product_id +
        //                               '_' +
        //                               slugify(v.initial_color)
        //                             : t.product_id + '_one-color',
        //                 })
        //             }
        //             return null
        //         })
        //         return null
        //     })

        //     allVariants = [...variantsWithTime]

        //     allVariants = [...new Set(allVariants)]

        //     // console.log('allVariants', allVariants)

        //     let carroVariants = allVariants.filter((v) => {
        //         if (v.fulfillment_service && v.fulfillment_service.length) {
        //             return v.fulfillment_service.indexOf('carro') > -1
        //         }
        //         return null
        //     })

        //     carroVariants = getUniqueListBy(carroVariants, 'product_id')

        //     let cortinaVariants = allVariants.filter((v) => {
        //         if (v.fulfillment_service && v.fulfillment_service.length) {
        //             return v.fulfillment_service.indexOf('cortina') > -1
        //         }
        //         return null
        //     })

        //     cortinaVariants = getUniqueListBy(cortinaVariants, 'product_id')

        //     // console.log(
        //     //     'carroVariants, cortinaVariants',
        //     //     carroVariants,
        //     //     cortinaVariants
        //     // )

        //     const variantsWithInventory = allVariants.filter((x) => {
        //         return x.inventory_quantity > 0
        //     })

        //     variantsWithInventoryRef.current = variantsWithInventory

        //     let uniques = variantsWithInventory.filter(
        //         (v, i, a) =>
        //             a.findIndex(
        //                 (t) =>
        //                     t.product_id === v.product_id &&
        //                     t.initial_color === v.initial_color
        //             ) === i
        //     )

        //     // console.log('uniques', uniques)

        //     console.log('no query string')
        //     uniqueVariants = [...uniques, ...carroVariants, ...cortinaVariants]

        //     uniqueVariants = getUniqueListBy(uniqueVariants, 'id')

        //     console.log('data way down here', uniqueVariants)
        // }

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
                /* you can also use 'auto' behaviour
                in place of 'smooth' */
            })
        }

        const NoProductsFound = () => (
            <div className="no-product-found">
                <p className="heading">
                    Uh oh! Looks like there aren't any matching products right
                    now.
                </p>
            </div>
        )

        // console.log('numProductsRemaining', numProductsRemaining)

        return (
            <div className="collection-outer">
                <div className="collection-inner">
                    <div className="collection-header">
                        <h2 className="collection-title">
                            {collectionTitle ? collectionTitle : ''}
                        </h2>
                        {/* <div className="collection-description">
                            {collectionDesc
                                ? ReactHtmlParser(collectionDesc)
                                : ''}
                        </div> */}
                    </div>
                    <div
                        className={`products-wrap ${
                            isMobile
                                ? 'products-wrap-mobile'
                                : 'products-wrap-desktop'
                        }`}
                    >
                        <div className={`products-outer`}>
                            <div className={`products-inner`}>
                                {productTiles ? (
                                    <ul className={`product-list`}>
                                        {productTiles.map((p) => {
                                            console.log('p productData', p)
                                            return (
                                                <ProductTile key={p.title} productData={p} />

                                            )

                                        })}
                                    </ul>
                                ) : (
                                    <div>No products found.</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
)

export default Collection
